export default class AdminCommonComplaints {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.adminCommonComplaintsEndpoint, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminCommonComplaintsEndpoint}/${id}`, {})
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminCommonComplaintsEndpoint}/export/all`, {
      params,
      responseType: "blob"
    })
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminCommonComplaintsEndpoint}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminCommonComplaintsEndpoint}/${id}`, payload, {})
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.adminCommonComplaintsEndpoint}/${id}`, {})
  }
}
